import { Box, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';

import MainButton from '@/components/UI/mobile/MainButton';
import useService from '@/lib/hooks/useService';
import type { FixRecord } from '@/types/database/fixRecord';

import { statusColors } from '../../helpers';
import type { FixSubPage } from '../../types';
import ImageElement from '../UI/ImageElement';
import Info from '../UI/Info';
import { CardWrapper, ContentBox, HeaderBox, Status } from '../UI/styles';

const FixProgress: FixSubPage = ({ selectedFix, onClose }) => {
  const [fixRecords] = useService<FixRecord>({
    collectionName: 'fixRecords',
    query: { fixId: selectedFix._id },
  });

  console.log({ selectedFix, fixRecords });

  const records: Record<'booked' | 'dealing' | 'finish', FixRecord | null> = {
    finish: null,
    dealing: null,
    booked: null,
  };

  fixRecords?.forEach((record) => {
    if (record.status === '已安排') {
      records.booked = record;
    } else if (record.status === '處理中') {
      records.dealing = record;
    } else if (record.status === '已處理') {
      records.finish = record;
    }
  });

  return (
    <Box
      sx={{
        height: '100%',
      }}
    >
      <CardWrapper
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          maxHeight: '100%',
          overflowY: 'auto',
        }}
      >
        {Object.values(records).map(
          (record) =>
            record && (
              <Box
                key={record._id}
                sx={{
                  backgroundColor: '#ffffff',
                  boxShadow: '0 0.1rem 0.1rem 0 rgba(0, 0, 0, 0.05)',
                }}
              >
                <HeaderBox>
                  <Status $bg={statusColors[record.status]}>
                    {record.status}
                  </Status>
                  <Typography
                    sx={{
                      fontWeight: '500',
                      fontSize: '0.9rem',
                    }}
                  >
                    {moment(record.createdTime).format('YYYY-MM-DD HH:mm')}
                  </Typography>
                </HeaderBox>
                <ContentBox>
                  <Info label="處理人" value={record.repairerName} />
                  <Info
                    label="處理時間"
                    value={moment(record.repairedTime).format(
                      'YYYY-MM-DD HH:mm'
                    )}
                  />
                  <Info label="處理內容" value={record.content} />
                  {record.image && (
                    <Info
                      label="圖片"
                      value={<ImageElement image={record.image.path} />}
                    />
                  )}
                </ContentBox>
              </Box>
            )
        )}
        <MainButton
          onClick={onClose}
          sx={{
            width: 'unset',
            position: 'sticky',
            bottom: '0',
          }}
        >
          返回
        </MainButton>
      </CardWrapper>
    </Box>
  );
};

export default FixProgress;
